import axios from "axios";
import type {
  InternetBgpConfig,
  InternetP2PAddressing,
} from "../internetAddressing";

const API_URL = process.env.REACT_APP_API_URL || "";

/**
 * GET /v1/resource-manager/internet
 * Get list of Internet services
 */
export function getInternetServices(token: string) {
  return axios.get(`${API_URL}/v1/resource-manager/ke-internet`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

/**
 * GET /v1/resource-manager/internet/:id
 * Get Internet service by ID
 */
export function getInternetServiceById(token: string, id: string | number) {
  return axios.get(`${API_URL}/v1/resource-manager/ke-internet/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

/**
 * POST /v1/resource-manager/internet
 * Create new Internet service
 */
export type P2pAddressing = InternetP2PAddressing;

export interface AddInternetPayload {
  kontrolEdgePortId: number;
  mbps: number;
  vlan: number;
  automaticVlan: boolean;
  redundancy: boolean;
  countryCode: string;
  routing: string;
  terms: number;
  autoRenew: boolean;
  p2pAddressing: P2pAddressing;
  bgpConfig?: InternetBgpConfig;
  subscriptionId: string;
  name: string;
  tag: string[];
  isDraft?: boolean;
}

export function addInternetService(token: string, payload: AddInternetPayload) {
  return axios.post(`${API_URL}/v1/resource-manager/ke-internet`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
}

/**
 * PUT /v1/resource-manager/internet/:id
 * Update Internet service
 */
export interface UpdateInternetPayload {
  kontrolEdgePortId?: number;
  mbps: number;
  vlan?: number;
  automaticVlan?: boolean;
  redundancy?: boolean;
  countryCode?: string;
  routing?: string;
  terms?: number;
  autoRenew?: boolean;
  p2pAddressing?: P2pAddressing;
  bgpConfig?: InternetBgpConfig;
  subscriptionId?: string;
  name: string;
  tag?: string[];
  isDraft?: boolean;
  latencyTargets?: Record<string, Record<string, string[]>> | null;
}

export function updateInternetService(
  token: string,
  id: string | number,
  payload: UpdateInternetPayload
) {
  const encodedId = encodeURIComponent(String(id));
  return axios.put(`${API_URL}/v1/resource-manager/ke-internet/${encodedId}`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
}

/**
 * DELETE /v1/resource-manager/internet/:id
 * Delete Internet service
 */
export function deleteInternetService(token: string, id: string | number) {
  const encodedId = encodeURIComponent(String(id));
  return axios.delete(`${API_URL}/v1/resource-manager/ke-internet/${encodedId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

